import React, { useEffect, useMemo, useState } from 'react';
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import Editor from 'ckeditor5-startmobile';
import 'ckeditor5-startmobile/build/translations/ru';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';
import defaultConfig from './config';

type Props = {
  html: string;
  setEditorStateCallback: any;
  disabled?: boolean;
};

export const CkEditorCustom: React.FC<Props> = ({
  html,
  setEditorStateCallback,
  disabled = false,
}) => {
  const styles1 = useStyles();
  const { classes } = styles1;
  const intl = useIntl();
  const [localEditorState, setLocalEditorState] = useState<any>();

  const config = useMemo(() => ({ ...defaultConfig, language: { ui: intl.locale } }), [intl]);

  useEffect(() => {
    if (localEditorState) localEditorState.setData(html);
  }, [localEditorState, html]);

  return (
    <div className={classes.container}>
      <CKEditor
        disabled={disabled}
        editor={Editor}
        config={config}
        data={html}
        onReady={(editor: any) => {
          setLocalEditorState(editor);
          setEditorStateCallback(editor);
        }}
        // onChange={(event: any, editor: any) => {
        // const data = editor.getData();
        // setGetHtmlCallback(editor);
        // }}
        // onBlur={(event: any, editor: any) => {
        //   console.log('Blur.', editor, event);
        // }}
        // onFocus={(event: any, editor: any) => {
        //   console.log('Focus.', editor, event);
        // }}
      />
    </div>
  );
};
